<template>
  <main class="main page-inside products-page">
    <div class="main-wrapper">
      <div class="section shop-section">
        <div class="wrapper">
          <div class="title big">{{ $t(`SHOP OUR ITEMS`) }}</div>
          <div class="filters">
            <div class="sort">
              <div class="select-container" v-if="categories && categories.length">
                <Select2 class="select2 single" v-model="activeCategory" 
                :options="categories" 
                :placeholder="$t('ALL CATEGORiES')"
                @select="selectCategory($event)"
                />
              </div>
              <div class="select-container" v-if="sortOptions.length">
                <Select2 class="select2 single" v-model="sort" 
                :options="sortOptions" 
                :placeholder="$t('SORT BY CHEAPEST')"
                @select="selectSort($event)"
                />
              </div>
            </div>
            <div class="search">
              <input type="text" :placeholder="$t('Search')" v-model="searchedProductText" @keyup.enter="searchSubmit"/>
              <div class="button" @click="searchSubmit">
                <img src="../images/glass.svg" class="img"/>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="product-list" v-if="productList && productList.data && productList.data.length">
              <div class="item" v-for="item in productList.data" :key="item.id" @click="openProductModal(item)">
                <img :src="imgDomain + item.img + '.png'" class="img"/>
                <div class="top">
                  <span class="name desc">{{item.name}}</span>
                </div>
                <div class="bottom">
                  <div class="available desc">{{ $t(`Available`) }}</div>
                  <!-- <div class="available desc not">{{ $t(`Not available`) }}</div> -->
                  <div class="price-container">
                    <span class="price">
                      <!-- Зачеркнутая цена со скидкой (сверху) -->
                      <span v-if="getOriginalPrice(item) && parseFloat(getOriginalPrice(item)) > parseFloat(item.price)" class="original-price">
                        <img src="../images/coin.svg" class="currency-icon" alt="coin"/>
                        <span class="title small amount">{{parseFloat(getOriginalPrice(item)).toFixed(2)}}</span>
                      </span>
                      <!-- Текущая цена (снизу) -->
                      <span class="price-content">
                        <img src="../images/coin.svg" class="currency-icon" alt="coin"/>
                        <span class="title medium amount">{{item.price.toFixed(2)}}</span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <transition name="fade">
            <div class="title-tiny no-products" v-if="!productList || !productList.data || !productList.data.length">{{ $t(`Loading products...`) }}</div>
          </transition>
          <pagination v-if="totalProducts" v-model="activePage" :per-page="24" :records="totalProducts" @paginate="changePage"/>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import Pagination from 'vue-pagination-2';
import Select2 from 'vue3-select2-component';

export default {
  name: 'Products',
  props: ['currency', 'currencyCode'],
  components: {
    Pagination,
    Select2
  },
  data: function() {
    return {
      imgDomain: '',
      productList: [],
      activePage: 1,
      totalProducts: null,
      searchedProductText: '',
      activeCategory: '',
      oldActiveCategory: '',
      sort: 'price',
      categories: [],
      sortOptions: [
        {
          id: 'price',
          text:'SORT BY CHEAPEST'
        }, 
        {
          id: '-price',
          text: 'SORT BY EXPENSIVE'
        }
      ],
    }
  },
  watch: {
    currencyCode: function () {
      this.filterProducts();
    }
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.getCategories();
    this.$http.get(process.env.VUE_APP_API + 'items?per_page=24')
    .then((res) => {
      console.log('API Response:', res.data); // Debug: посмотрим структуру данных
      console.log('First item structure:', res.data.data[0]); // Посмотрим структуру первого товара
      this.productList = res.data;
      this.totalProducts = res.data.meta.total;
      
      // Проверяем, какие поля есть у товаров для скидки
      if (this.productList.data && this.productList.data.length > 0) {
        console.log('Checking discount fields for all items:');
        this.productList.data.forEach((item, index) => {
          console.log(`Item ${index}:`, {
            name: item.name,
            price: item.price,
            original_price: item.original_price,
            old_price: item.old_price,
            discount_price: item.discount_price,
            sale_price: item.sale_price,
            regular_price: item.regular_price,
            base_price: item.base_price,
            allFields: Object.keys(item)
          });
        });
        
        // Добавляем тестовую скидку для первого товара
        this.productList.data[0].original_price = (this.productList.data[0].price * 1.5).toFixed(2);
        console.log('Test discount for item 1:', this.productList.data[0].name, 'Price:', this.productList.data[0].price, 'Original:', this.productList.data[0].original_price);
        // Добавляем тестовую скидку для третьего товара
        if (this.productList.data[2]) {
          this.productList.data[2].original_price = (this.productList.data[2].price * 1.3).toFixed(2);
          console.log('Test discount for item 3:', this.productList.data[2].name, 'Price:', this.productList.data[2].price, 'Original:', this.productList.data[2].original_price);
        }
      }
    })
    .catch((res) => {
      if(res.response.status === 401) {
        this.$parent.openSignInModal();
      }
    })
  },
  methods: {
    getCategories() {
      this.$http.get(process.env.VUE_APP_API + 'categories')
      .then((res) => {
        this.categories = res.data.payload.map(({ id, name, ...rest }) => ({
          id,
          text: name,
          ...rest,
        }));
        this.categories.unshift({ id: 0, text: 'ALL CATEGORIES' });
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    selectSort(event) {
      this.sort = event.id;
      this.filterProducts();
    },
    selectCategory(event) {
      this.activeCategory = event;
      this.activePage = 1;
      this.filterProducts();
    },
    goToProduct(item) {
      this.$parent.goToProduct(item);
    },
    changePage(page) {
      this.activePage = page;
      this.filterProducts();
    },
    searchSubmit() {
      this.filterProducts();
    },
    filterProducts() {
      let addSort = 'sort=' + this.sort
      let addPage = '&page=' + this.activePage
      let addSearch = '&filter[name]=' + this.searchedProductText
      let addcCategory;
      
      if (this.activeCategory.id == 0 || this.activeCategory == '') {
       addcCategory = '';
      } else {
        addcCategory = '&filter[category]=' + this.activeCategory.id
      }
      
      this.$http.get(process.env.VUE_APP_API + 'items?' + addSort + addPage + addSearch + addcCategory + '&per_page=24')
      .then((res) => {
        this.productList = res.data
        this.totalProducts = res.data.meta.total
        
        // Временные тестовые данные для демонстрации скидки
        if (this.productList.data && this.productList.data.length > 0) {
          // Добавляем тестовую скидку для первого товара
          this.productList.data[0].original_price = (this.productList.data[0].price * 1.5).toFixed(2);
          console.log('Test discount for item 1:', this.productList.data[0].name, 'Price:', this.productList.data[0].price, 'Original:', this.productList.data[0].original_price);
          // Добавляем тестовую скидку для третьего товара
          if (this.productList.data[2]) {
            this.productList.data[2].original_price = (this.productList.data[2].price * 1.3).toFixed(2);
            console.log('Test discount for item 3:', this.productList.data[2].name, 'Price:', this.productList.data[2].price, 'Original:', this.productList.data[2].original_price);
          }
        }
      })
      .catch(() => {
        
      })
    },
    openProductModal(product) {
      this.$emit('openProductModal', product)
    },
    getOriginalPrice(item) {
      // Проверяем разные возможные поля для оригинальной цены
      const possibleFields = [
        'original_price',
        'old_price', 
        'regular_price',
        'base_price',
        'list_price',
        'msrp',
        'retail_price',
        'full_price',
        'discount_price',
        'sale_price'
      ];
      
      for (let field of possibleFields) {
        if (item[field] && parseFloat(item[field]) > parseFloat(item.price)) {
          // console.log(`Found discount field "${field}" for ${item.name}:`, item[field], 'vs', item.price);
          return item[field];
        }
      }
      
      return null;
    }
  }
}
</script>